jQuery(document).ready(function () {

	jQuery(document).on("change", ".archivefilter .select-wrapper .filter-select-box", function () {
		debugger;
		var selected_dest = jQuery('#selectDest').val();
		var selected_exp = jQuery('#selectExp').val();
		var post_type = jQuery('#postypename').val();


		// After user click on tag, fade out list of posts
		jQuery('.filterbox').fadeOut();
		jQuery('#add-results').html('<div class="container text-center"><img alt="loading" src="'+afp_vars.loading_icon+'"></div>');
		setTimeout(function () {
			data = {
				action: 'filter_posts', // function to execute
				afp_nonce: afp_vars.afp_nonce, // wp_nonce
				selectDest: selected_dest,
				selectExp: selected_exp,
				postType: post_type,
			};
			jQuery.post(afp_vars.afp_ajax_url, data, function (response) {
				// console.log(response.data);
				if (response && response.success) {
					// Display posts on page
					jQuery('#add-results').html(response.data.posts_html);
					// Update pagination
					jQuery('.blog-list-card-pegination').replaceWith(response.data.pagination_html);
					// Restore div visibility
					jQuery('.filterbox').fadeIn();
				}
			});
		}, 500);
	});

});
